module.exports = __webpack_public_path__ + "img/add-image5.4afdebc7.png";